/* eslint-disable */
// eslint-disable-next-line no-unused-vars
import { Alert } from "@material-ui/lab";
import ModalResultado from "../ModalResultado/ModalResultado";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  updateGradesByStudent,
  updateVisibilityByStudent,
  getStoredVisibility,
  formatGradeValue as apiFormatGradeValue,
  formatSponteValue,
  cleanupLocalStorage
} from "../../api/autenticoAPI";
import { TitleLegend } from "../TitleLegend";
import {
  InputGradeAC1,
  InputGradeAC2,
  InputMB,
  InputMediaAC1,
  InputMediaAC2,
  InputMPR,
  InputName,
  InputRM,
  ListStudents,
  StudentsGrades,
} from "./styles";
import { Checkbox, Tooltip, Snackbar } from "@mui/material";
import { AlertDialog } from "../AlertDialog";
import { getGradesBySubject } from "../../api/sponteAPI";
import { logDebug } from "../../utils/logger";

export const GradeItem = ({
  aluno,
  legend,
  tabIndex,
  last,
  TurmaID,
  period,
  DisciplinaID,
  nomeDisciplina,
  classGrades,
  selectAll,
  setSelectAll,
  onSelectAllChange, // Nova prop para callback quando selectAll muda
  updateStudentVisibility,
  repeatGrades,
  validate,
  setValidate,
  onGradeSaved,
  sponteGradesData, // Dados do Sponte obtidos via batch (opcional)
}) => {
  const [nome, setNome] = useState(aluno.nome);
  const [AT1, setAT1] = useState("");
  const [AT2, setAT2] = useState("");
  const [AT3, setAT3] = useState("");
  const [AT4, setAT4] = useState("");
  const [AT5, setAT5] = useState("");
  const [AT6, setAT6] = useState("");
  const [AC1, setAC1] = useState("");
  const [AC2, setAC2] = useState("");
  const [MB, setMB] = useState("");
  const [RM, setRM] = useState("");
  const [MPR, setMPR] = useState("");
  const inputRef = useRef(null);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [openResultado, setOpenResultado] = useState(false);
  const [value, setValue] = useState("");
  const [currentSetter, setCurrentSetter] = useState("");
  const [gradeSponte, setGradeSponte] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ show: false, success: false, message: "" });
  const [lastSavedValues, setLastSavedValues] = useState({});
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [fieldToDelete, setFieldToDelete] = useState({ field: '', setter: null, previousValue: '' });
  
  // Ref para rastrear o período anterior e limpar estados quando mudar
  const prevPeriodRef = useRef(period);
  
  const clearMedia = useCallback((setter) => {
    setter("");
  }, []);

  const calcPartialMedia = useCallback(() => {
    // Se ambos AC1 e AC2 estiverem vazios, limpa MB
    if ((!AC1 || AC1 === "0,0" || AC1 === "0") && (!AC2 || AC2 === "0,0" || AC2 === "0")) {
      clearMedia(setMB);
      return;
    }
    
    const ac1Value = parseFloat((AC1 && AC1.replace(",", ".")) || 0);
    const ac2Value = parseFloat((AC2 && AC2.replace(",", ".")) || 0);
    
    // Se os valores são zero, também limpar MB
    if (ac1Value === 0 && ac2Value === 0) {
      clearMedia(setMB);
      return;
    }
    
    // Calcular a média e aplicar o mesmo arredondamento matemático
    const partialMedia = (ac1Value + ac2Value) / 2;
    
    // Arredondamento matemático para uma casa decimal (igual ao Sponte)
    // Math.round(x * 10) / 10 arredonda para uma casa decimal
    // Exemplo: 6.35 vira 6.4
    const roundedMedia = Math.round(partialMedia * 10) / 10;
    
    // Formatar com uma casa decimal e vírgula como separador
    const formattedMedia = roundedMedia.toFixed(1).replace(".", ",");
    setMB(formattedMedia);
  }, [AC1, AC2, clearMedia]);

  const clearLocalStorageData = (alunoId, turmaId, disciplinaId, periodo) => {
    try {
      logDebug(`[LIMPEZA LOCALSTORAGE] Removendo dados para aluno ${alunoId}`);
      
      // Buscar todas as chaves no localStorage para este aluno
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key) continue;
        
        // Se temos um período específico, usar apenas as chaves desse período
        if (periodo) {
          if (key.includes(`_${alunoId}_${turmaId}_${disciplinaId}_${periodo}`)) {
            logDebug(`[LIMPEZA LOCALSTORAGE] Removendo chave específica: ${key}`);
            localStorage.removeItem(key);
          }
        }
        // Se não temos período, remover todas as chaves deste aluno/turma/disciplina
        else if (key.includes(`_${alunoId}_${turmaId}_${disciplinaId}_`)) {
          logDebug(`[LIMPEZA LOCALSTORAGE] Removendo chave: ${key}`);
          localStorage.removeItem(key);
        }
      }
    } catch (e) {
      console.error("Erro ao limpar localStorage:", e);
    }
  };

  const updateGrades = async () => {
    // Evitar múltiplas chamadas simultâneas
    if (isSaving) return;
    
    try {
      setIsSaving(true);
      setErrorMessage(""); // Limpar mensagens de erro anteriores
      // Mostrar status de salvamento
      setSaveStatus({ show: true, success: true, message: "Salvando" });
      
      // Normalizar todos os valores para cálculos (trocar vírgulas por pontos)
      const normalizeValue = (val) => val ? parseFloat(val.toString().replace(",", ".")) : 0;
      
      const ac1Norm = normalizeValue(AC1);
      const ac2Norm = normalizeValue(AC2);
      const rmNorm = normalizeValue(RM);
      const mbNorm = normalizeValue(MB);
      
      // Validações de entrada
      const numericValues = [ac1Norm, ac2Norm, rmNorm].filter(val => val !== 0);
      const invalidValues = numericValues.some(val => isNaN(val) || val < 0 || val > 10);
      
      if (invalidValues) {
        setErrorText("Valores de notas devem ser números entre 0 e 10");
        setIsSaving(false);
        return;
      }
      
      // Validar se a soma das notas não excede limites razoáveis
      if ((ac1Norm > 0 && ac2Norm > 0) && (ac1Norm + ac2Norm > 20)) {
        setErrorText("A soma das notas AC1 e AC2 não pode exceder 20");
        setIsSaving(false);
        return;
      }
      
      // Calcular explicitamente AC1 e AC2 novamente para garantir consistência
      // Obter valores numéricos das atividades
      const at1Value = normalizeValue(AT1);
      const at2Value = normalizeValue(AT2);
      const at3Value = normalizeValue(AT3);
      const at4Value = normalizeValue(AT4);
      const at5Value = normalizeValue(AT5);
      const at6Value = normalizeValue(AT6);
      
      // Calcular AC1
      let calculatedAC1 = "";
      if (at1Value > 0 || at2Value > 0) {
        const soma = at1Value + at2Value;
        // Aplicar arredondamento para uma casa decimal
        const roundedSoma = Math.round(soma * 10) / 10;
        calculatedAC1 = roundedSoma.toFixed(1).replace(".", ",");
      }
      
      // Calcular AC2
      let calculatedAC2 = "";
      if (at3Value > 0 || at4Value > 0 || at5Value > 0 || at6Value > 0) {
        const soma = at3Value + at4Value + at5Value + at6Value;
        // Aplicar arredondamento para uma casa decimal
        const roundedSoma = Math.round(soma * 10) / 10;
        calculatedAC2 = roundedSoma.toFixed(1).replace(".", ",");
      }
      
      // Atualizar AC1 e AC2 nos estados imediatamente para evitar inconsistência
      setAC1(calculatedAC1);
      setAC2(calculatedAC2);
      
      // Calcular MB
      let calculatedMB = "";
      if (calculatedAC1 || calculatedAC2) {
        const ac1Num = parseFloat((calculatedAC1 && calculatedAC1.replace(",", ".")) || 0);
        const ac2Num = parseFloat((calculatedAC2 && calculatedAC2.replace(",", ".")) || 0);
        
        if (ac1Num > 0 || ac2Num > 0) {
          const media = (ac1Num + ac2Num) / 2;
          // Arredondamento matemático para uma casa decimal
          const roundedMedia = Math.round(media * 10) / 10;
          calculatedMB = roundedMedia.toFixed(1).replace(".", ",");
        }
      }
      
      // Atualizar MB no estado
      setMB(calculatedMB);
      
      // Chamada para atualizar as notas
      const result = await updateGradesByStudent(
        aluno.AlunoID,
        TurmaID,
        DisciplinaID,
        period,
        AT1 || "",
        AT2 || "",
        AT3 || "",
        AT4 || "",
        AT5 || "",
        AT6 || "",
        calculatedAC1,
        calculatedAC2,
        RM,
        calculatedMB,
        nomeDisciplina,
        visible
      );
      
      if (result) {
        logDebug("Notas atualizadas com sucesso:", {
          AC1: calculatedAC1,
          AC2: calculatedAC2,
          MB: calculatedMB
        });
        
        // Limpar quaisquer dados salvos no localStorage
        clearLocalStorageData(aluno.AlunoID, TurmaID, DisciplinaID, period);
        
        // Substituir setSuccessText e setSuccess por setSaveStatus
        setSaveStatus({ show: true, success: true, message: "Notas salvas" });
        
        // Atualizar lastSavedValues
        setLastSavedValues({
          at1: AT1,
          at2: AT2,
          at3: AT3,
          at4: AT4,
          at5: AT5,
          at6: AT6,
          ac1: calculatedAC1,
          ac2: calculatedAC2,
          rm: RM,
          mb: calculatedMB,
          visibility: visible,
          period: period
        });
        if (typeof onGradeSaved === 'function') {
          onGradeSaved({
            AlunoID: aluno.AlunoID,
            at1: AT1,
            at2: AT2,
            at3: AT3,
            at4: AT4,
            at5: AT5,
            at6: AT6,
            ac1: calculatedAC1,
            ac2: calculatedAC2,
            rm: RM,
            mb: calculatedMB,
            visibility: visible,
            period: period
          });
        }
      } else {
        throw new Error("Falha na atualização das notas");
      }
    } catch (error) {
      console.error("Erro ao atualizar notas:", error);
      setErrorText("Erro ao salvar notas. Tente novamente.");
    } finally {
      setIsSaving(false);
    }
  };

  const calcMPR = useCallback(() => {
    // Limpar MPR se tanto MB quanto RM estiverem vazios
    if ((!MB || MB === "0,0" || MB === "0") && (!RM || RM === "0,0" || RM === "0")) {
      setMPR("");
      return;
    }
    
    // Verificar se já existe um valor para MB
    if (MB && MB !== "0,0" && MB !== "0") {
      // Converter as notas para números (usando o formato brasileiro)
      const mbValue = parseFloat(String(MB).replace(",", "."));
      const rmValue = RM ? parseFloat(String(RM).replace(",", ".")) : 0;
      
      if (!isNaN(mbValue) && !isNaN(rmValue) && rmValue > 0) {
        // Determinar qual é o maior valor entre MB e RM
        const maxValue = mbValue > rmValue ? mbValue : rmValue;
        
        // Aplicar arredondamento matemático para uma casa decimal
        const roundedValue = Math.round(maxValue * 10) / 10;
        
        // Formatar com uma casa decimal, usando vírgula como separador
        const formattedValue = roundedValue.toFixed(1).replace(".", ",");
        setMPR(formattedValue);
      } else if (!isNaN(mbValue)) {
        // Mesmo arredondamento para MB
        const roundedValue = Math.round(mbValue * 10) / 10;
        const formattedValue = roundedValue.toFixed(1).replace(".", ",");
        setMPR(formattedValue);
      } else if (!isNaN(rmValue) && rmValue > 0) {
        // Mesmo arredondamento para RM
        const roundedValue = Math.round(rmValue * 10) / 10;
        const formattedValue = roundedValue.toFixed(1).replace(".", ",");
        setMPR(formattedValue);
      } else {
        setMPR("");
      }
    } else if (RM && RM !== "0,0" && RM !== "0") {
      const rmValue = parseFloat(String(RM).replace(",", "."));
      if (!isNaN(rmValue) && rmValue > 0) {
        // Mesmo arredondamento para RM quando é a única nota
        const roundedValue = Math.round(rmValue * 10) / 10;
        const formattedValue = roundedValue.toFixed(1).replace(".", ",");
        setMPR(formattedValue);
      } else {
        setMPR("");
      }
    } else {
      setMPR("");
    }
  }, [MB, RM]);

  // Função auxiliar para processar dados de notas
  // SIMPLIFICADA baseada na versão antiga que funcionava
  const processGradeData = useCallback((res) => {
    // Na versão antiga, funcionava assim: res[`Nota${period}`]
    // Mas agora Nota4 pode estar vazio, então tentamos NotaAposRec4 (nota após recuperação) ou MediaFinal
    const periodKey = `Nota${period}`;
    const notaAposRecKey = `NotaAposRec${period}`;
    
    // Obter a nota do Sponte - prioridade: NotaAposRec (nota após recuperação) > Nota > MediaFinal > Media
    // NotaAposRec é a nota final do período após recuperação, que é o que queremos comparar com MPR
    // IMPORTANTE: O Sponte retorna string vazia ('') quando não há nota, então precisamos verificar explicitamente
    let sponteGrade = null;
    
    // Verificar NotaAposRec primeiro (nota após recuperação - é a nota final do período)
    if (res[notaAposRecKey] && res[notaAposRecKey] !== '' && res[notaAposRecKey] !== null && res[notaAposRecKey] !== undefined) {
      sponteGrade = res[notaAposRecKey];
    }
    // Se não houver NotaAposRec, tentar Nota do período
    else if (res[periodKey] && res[periodKey] !== '' && res[periodKey] !== null && res[periodKey] !== undefined) {
      sponteGrade = res[periodKey];
    }
    // Se não houver Nota do período, tentar MediaFinal
    else if (res.MediaFinal && res.MediaFinal !== '' && res.MediaFinal !== null && res.MediaFinal !== undefined) {
      sponteGrade = res.MediaFinal;
    }
    // Por último, tentar Media
    else if (res.Media && res.Media !== '' && res.Media !== null && res.Media !== undefined) {
      sponteGrade = res.Media;
    }
    
    // Formatar a nota do Sponte para garantir a mesma formatação (igual versão antiga)
    let formattedSponteGrade = "";
    if (sponteGrade) {
      // Converter para número e depois formatar com uma casa decimal
      const sponteValue = parseFloat(String(sponteGrade).replace(',', '.'));
      if (!isNaN(sponteValue) && sponteValue > 0) {
        formattedSponteGrade = sponteValue.toFixed(1).replace('.', ',');
      }
    }
    // Atualizar o estado com a nota do Sponte formatada (pode ser string vazia se não houver nota)
    setGradeSponte(formattedSponteGrade);
  }, [aluno.AlunoID, period]);

  const validateGrades = useCallback(() => {
    // Se temos dados do batch, usar eles primeiro (mais eficiente e evita rate limiting)
    // IMPORTANTE: Verificar tanto com string quanto com number, pois o AlunoID pode vir em formatos diferentes
    const alunoIDString = String(aluno.AlunoID);
    const alunoIDNumber = Number(aluno.AlunoID);
    const batchData = sponteGradesData && (
      sponteGradesData[aluno.AlunoID] || 
      sponteGradesData[alunoIDString] || 
      sponteGradesData[alunoIDNumber]
    );
    
    if (batchData) {
      processGradeData(batchData);
      return;
    }
    
    // Se não temos dados do batch, fazer requisição individual (fallback)
    getGradesBySubject(aluno.AlunoID, TurmaID, DisciplinaID).then((res) => {
      processGradeData(res);
    }).catch((error) => {
      console.error(`[validateGrades] Erro ao buscar notas do Sponte para aluno ${aluno.AlunoID}:`, error);
      
      // Se for erro 429, não tentar novamente
      if (error.response?.status === 429 || error.rateLimitExceeded) {
        setGradeSponte("");
        return;
      }
      
      setGradeSponte("");
    });
  }, [aluno.AlunoID, TurmaID, DisciplinaID, period, processGradeData, sponteGradesData]);

  useEffect(() => {
    if (validate) {
      validateGrades();
    }
    // IMPORTANTE: Não limpar gradeSponte quando validate voltar para false
    // gradeSponte deve persistir para que a divergência continue visível
  }, [validate, validateGrades, sponteGradesData, aluno.AlunoID]); // Adicionar aluno.AlunoID para garantir que o log seja específico

  // Limpar gradeSponte apenas quando período ou disciplina mudarem
  useEffect(() => {
    setGradeSponte("");
  }, [period, DisciplinaID, aluno.AlunoID]);

  // A divergência é calculada diretamente na renderização (igual versão antiga)
  // Não precisamos de useEffect separado - a comparação gradeSponte !== MPR já é feita no style

  useEffect(() => {
    // Verificar se updateStudentVisibility mudou (e não é zero)
    if (updateStudentVisibility !== 0) {
      logDebug(`Atualizando visibilidade para aluno ${aluno.AlunoID} devido a atualização em massa (contador: ${updateStudentVisibility})`);
      
      // Não precisamos mais chamar API aqui, pois a atualização em massa já foi feita
      // A visibilidade foi atualizada pelo componente pai (Grades.js)
      // Apenas atualizamos o estado local para refletir o selectAll
      
      // Recuperar a visibilidade mais recente (pode ter sido alterada pela atualização em massa)
      // Primeiro tentamos ler do localStorage como fonte mais confiável
      const storedVisibility = getStoredVisibility(aluno.AlunoID, TurmaID, DisciplinaID, period);
      
      if (storedVisibility !== null) {
        logDebug(`Atualizando estado local com visibilidade do localStorage para aluno ${aluno.AlunoID}: ${storedVisibility}`);
        setVisible(storedVisibility);
      } else if (classGrades && classGrades.grades && Array.isArray(classGrades.grades)) {
        // Se não encontrou no localStorage, tenta encontrar nas notas carregadas
        const studentGrades = classGrades.grades.filter(
          (item) => String(item.AlunoID) === String(aluno.AlunoID)
        );
        if (studentGrades[0] && studentGrades[0].visibility !== undefined) {
          logDebug(`Atualizando estado local com visibilidade das notas para aluno ${aluno.AlunoID}: ${studentGrades[0].visibility}`);
          setVisible(studentGrades[0].visibility);
        }
      }
    }
  }, [
    updateStudentVisibility,
    aluno.AlunoID,
    TurmaID,
    DisciplinaID,
    period,
    classGrades
  ]);

  useEffect(() => {
    setVisible(selectAll);
  }, [selectAll]);

  // Limpar estados quando o período mudar
  useEffect(() => {
    if (prevPeriodRef.current !== period && prevPeriodRef.current !== undefined) {
      // Limpar todos os campos quando o período muda
      setAT1("");
      setAT2("");
      setAT3("");
      setAT4("");
      setAT5("");
      setAT6("");
      setAC1("");
      setAC2("");
      setMB("");
      setRM("");
      setMPR("");
      setLastSavedValues({});
    }
    prevPeriodRef.current = period;
  }, [period, aluno.AlunoID]);

  useEffect(() => {
    // Não buscar dados do localStorage, usar apenas os dados do servidor
    if (classGrades && classGrades.grades && Array.isArray(classGrades.grades)) {
      const studentGrades = classGrades.grades.filter(
        (item) => String(item.AlunoID) === String(aluno.AlunoID)
      );
      
      if (studentGrades[0]) {
        // IMPORTANTE: Verificar se o período é o correto
        // Normalizar ambos para número para comparação consistente
        const serverPeriod = Number(studentGrades[0].period);
        const currentPeriod = Number(period);
        
        if (studentGrades[0].period !== undefined && !isNaN(serverPeriod) && !isNaN(currentPeriod) && serverPeriod !== currentPeriod) {
          // Silenciosamente ignorar se o período estiver errado - não é um erro crítico
          return;
        }
        // Função mais robusta para detecção de valores vazios/zero
        const isEmptyOrZero = (value) => {
          if (value === null || value === undefined || value === "") return true;
          if (value === 0 || value === "0" || value === "0,0" || value === "0.0") return true;
          if (typeof value === "string" && value.trim() === "") return true;
          const numValue = parseFloat(String(value).replace(",", "."));
          return isNaN(numValue) || numValue === 0;
        };
        
        // Formatamos as notas garantindo que zeros sejam string vazia
        const formattedValues = {
          at1: isEmptyOrZero(studentGrades[0].at1) ? "" : formatGradeValue(studentGrades[0].at1),
          at2: isEmptyOrZero(studentGrades[0].at2) ? "" : formatGradeValue(studentGrades[0].at2),
          at3: isEmptyOrZero(studentGrades[0].at3) ? "" : formatGradeValue(studentGrades[0].at3),
          at4: isEmptyOrZero(studentGrades[0].at4) ? "" : formatGradeValue(studentGrades[0].at4),
          at5: isEmptyOrZero(studentGrades[0].at5) ? "" : formatGradeValue(studentGrades[0].at5),
          at6: isEmptyOrZero(studentGrades[0].at6) ? "" : formatGradeValue(studentGrades[0].at6),
          ac1: isEmptyOrZero(studentGrades[0].ac1) ? "" : formatGradeValue(studentGrades[0].ac1),
          ac2: isEmptyOrZero(studentGrades[0].ac2) ? "" : formatGradeValue(studentGrades[0].ac2),
          rm: isEmptyOrZero(studentGrades[0].rm) ? "" : formatGradeValue(studentGrades[0].rm),
          visibility: studentGrades[0].visibility,
        };
        
        // Verificar se os valores são diferentes dos atuais antes de atualizar
        // IMPORTANTE: Se o período mudou, sempre atualizar mesmo que os valores sejam iguais
        // Isso garante que dados de períodos anteriores não fiquem "presos" na tela
        const hasChanges = 
          AT1 !== formattedValues.at1 ||
          AT2 !== formattedValues.at2 ||
          AT3 !== formattedValues.at3 ||
          AT4 !== formattedValues.at4 ||
          AT5 !== formattedValues.at5 ||
          AT6 !== formattedValues.at6 ||
          AC1 !== formattedValues.ac1 ||
          AC2 !== formattedValues.ac2 ||
          RM !== formattedValues.rm ||
          visible !== formattedValues.visibility;
        
        // Se não há mudanças mas o período corresponde, ainda assim atualizar
        // para garantir que valores null sejam processados corretamente
        const shouldUpdate = hasChanges || (serverPeriod === currentPeriod && !isNaN(serverPeriod) && !isNaN(currentPeriod));
        
        if (shouldUpdate) {
          // Atualizamos os estados com os valores formatados
          setAT1(formattedValues.at1);
          setAT2(formattedValues.at2);
          setAT3(formattedValues.at3);
          setAT4(formattedValues.at4);
          setAT5(formattedValues.at5);
          setAT6(formattedValues.at6);
          setAC1(formattedValues.ac1);
          setAC2(formattedValues.ac2);
          setRM(formattedValues.rm);
          
          // Ignorar localStorage, usar visibilidade do servidor
          setVisible(formattedValues.visibility || false);
          
          // Calcular a média parcial baseada nos valores carregados
          // Verificar se temos AC1 ou AC2 com valores
          const ac1Value = parseFloat((formattedValues.ac1 && formattedValues.ac1.replace(",", ".")) || 0);
          const ac2Value = parseFloat((formattedValues.ac2 && formattedValues.ac2.replace(",", ".")) || 0);
          
          if (ac1Value > 0 || ac2Value > 0) {
            const partialMedia = (ac1Value + ac2Value) / 2;
            const roundedMedia = Math.round(partialMedia * 10) / 10;
            const formattedMedia = roundedMedia.toFixed(1).replace(".", ",");
            setMB(formattedMedia);
          } else {
            setMB("");
          }
          
          // Salvar os valores atuais como o último estado salvo para comparações futuras
          setLastSavedValues({
            at1: formattedValues.at1,
            at2: formattedValues.at2,
            at3: formattedValues.at3,
            at4: formattedValues.at4,
            at5: formattedValues.at5,
            at6: formattedValues.at6,
            ac1: formattedValues.ac1,
            ac2: formattedValues.ac2,
            rm: formattedValues.rm,
            visibility: formattedValues.visibility || false
          });
          
        }
      } else {
      }
    } else {
    }
  }, [TurmaID, DisciplinaID, aluno.AlunoID, classGrades, period]);

  useEffect(() => {
    calcPartialMedia();
  }, [calcPartialMedia]);

  useEffect(() => {
    // Chamamos apenas a função sem colocá-la como dependência
    calcMPR();
    // Dependências são MB e RM diretamente
  }, [MB, RM]);

  // Removido useEffect de desmontagem com log desnecessário
  
  // Removido useEffect de render com logs excessivos que causavam re-renders

  // Resto das funções do componente
  const addDecimalIfNeeded = (value) => {
    if (!value.includes(",")) {
      return value + ",0";
    }
    return value;
  };

  /**
   * Define o texto de erro e configura o estado de erro
   * @param {string} mensagem - Mensagem de erro a ser exibida
   */
  const setErrorText = (mensagem) => {
    // Atualizar para usar apenas setSaveStatus em vez de estados separados
    setSaveStatus({ 
      show: true, 
      success: false, 
      message: mensagem 
    });
    
    // Limpar mensagem de erro após 4 segundos
    setTimeout(() => {
      setSaveStatus(prev => ({ ...prev, show: false }));
    }, 4000);
    
    // Manter o log
    console.error("Erro:", mensagem);
  };

  /**
   * Formata o valor da nota para exibição
   * @param {string|number} valor - Valor da nota a ser formatado
   * @returns {string} Valor formatado
   */
  const formatGradeValue = (valor) => {
    // Casos especiais para valores zero ou equivalentes - sempre retornar string vazia
    if (valor === null || valor === undefined || valor === "" || 
        valor === "0" || valor === "0,0" || valor === 0 || valor === "0.0" || valor === 0.0) {
      return "";
    }
    
    try {
      // Converter para número para verificação mais precisa
      const numValor = parseFloat(String(valor).replace(",", "."));
      
      // Se for zero ou NaN, retornar string vazia
      if (isNaN(numValor) || numValor === 0) {
        return "";
      }
      
      // Para valores não-zero, formatar com arredondamento e uma casa decimal
      const roundedValue = Math.round(numValor * 10) / 10;
      return roundedValue.toFixed(1).replace(".", ",");
    } catch (e) {
      console.error("Erro ao formatar valor de nota:", e);
      return "";
    }
  };

  const handleChange = (event, setter) => {
    const inputValue = event.target.value;
    const isValidInput = /^[0-9,]*$/.test(inputValue);
    
    inputRef.current = document.activeElement;
    
    // Se estamos apagando uma nota existente (input vazio)
    if (inputValue === '') {
      // Verificamos qual campo está sendo editado e seu valor antigo
      let previousValue = '';
      let fieldName = '';
      
      if (setter === setAT1) { 
        previousValue = AT1;
        fieldName = 'AT1';
      } else if (setter === setAT2) { 
        previousValue = AT2;
        fieldName = 'AT2';
      } else if (setter === setAT3) { 
        previousValue = AT3;
        fieldName = 'AT3';
      } else if (setter === setAT4) { 
        previousValue = AT4;
        fieldName = 'AT4';
      } else if (setter === setAT5) { 
        previousValue = AT5;
        fieldName = 'AT5';
      } else if (setter === setAT6) { 
        previousValue = AT6;
        fieldName = 'AT6';
      } else if (setter === setRM) { 
        previousValue = RM;
        fieldName = 'RM';
      }
      
      // Se o valor não era vazio ou zero, mostrar confirmação
      if (previousValue && previousValue !== '' && previousValue !== '0' && previousValue !== '0,0') {
        setFieldToDelete({
          field: fieldName,
          setter: setter,
          previousValue: previousValue
        });
        setShowDeleteConfirm(true);
        return;
      } else {
        // Se era vazio ou zero, apagar diretamente
        setter("");
        
        return;
      }
    }
    
    // Para entradas válidas, atualizar o estado
    if (isValidInput) {
      setter(inputValue);
    }
  };

  // Função para confirmar a exclusão de uma nota
  const confirmDeletion = async () => {
    // Fechar diálogo
    setShowDeleteConfirm(false);
    
    // Criar cópia dos valores atuais
    let updatedFields = {
      at1: AT1 || "",
      at2: AT2 || "",
      at3: AT3 || "",
      at4: AT4 || "",
      at5: AT5 || "",
      at6: AT6 || "",
      rm: RM || "",
      ac1: AC1 || "",
      ac2: AC2 || "",
      mb: MB || "",
      visibility: visible
    };
    
    // Limpar o campo específico
    if (fieldToDelete.field === 'AT1') {
      updatedFields.at1 = '';
      setAT1('');
    } 
    else if (fieldToDelete.field === 'AT2') {
      updatedFields.at2 = '';
      setAT2('');
    }
    else if (fieldToDelete.field === 'AT3') {
      updatedFields.at3 = '';
      setAT3('');
    }
    else if (fieldToDelete.field === 'AT4') {
      updatedFields.at4 = '';
      setAT4('');
    }
    else if (fieldToDelete.field === 'AT5') {
      updatedFields.at5 = '';
      setAT5('');
    }
    else if (fieldToDelete.field === 'AT6') {
      updatedFields.at6 = '';
      setAT6('');
    }
    else if (fieldToDelete.field === 'RM') {
      updatedFields.rm = '';
      setRM('');
    }
    
    // Recalcular AC1, AC2, MB e MPR com base nos valores atualizados
    let newAC1 = "";
    let newAC2 = "";
    let newMB = "";
    let newMPR = "";
    
    // Recalcular AC1
    const at1Value = parseFloat((updatedFields.at1 && updatedFields.at1.replace(",", ".")) || 0);
    const at2Value = parseFloat((updatedFields.at2 && updatedFields.at2.replace(",", ".")) || 0);
    
    if (at1Value > 0 || at2Value > 0) {
      const soma = at1Value + at2Value;
      const roundedSoma = Math.round(soma * 10) / 10;
      newAC1 = roundedSoma.toFixed(1).replace(".", ",");
    }
    
    // Recalcular AC2
    const at3Value = parseFloat((updatedFields.at3 && updatedFields.at3.replace(",", ".")) || 0);
    const at4Value = parseFloat((updatedFields.at4 && updatedFields.at4.replace(",", ".")) || 0);
    const at5Value = parseFloat((updatedFields.at5 && updatedFields.at5.replace(",", ".")) || 0);
    const at6Value = parseFloat((updatedFields.at6 && updatedFields.at6.replace(",", ".")) || 0);
    
    if (at3Value > 0 || at4Value > 0 || at5Value > 0 || at6Value > 0) {
      const soma = at3Value + at4Value + at5Value + at6Value;
      const roundedSoma = Math.round(soma * 10) / 10;
      newAC2 = roundedSoma.toFixed(1).replace(".", ",");
    }
    
    // Atualizar states para AC1 e AC2
    setAC1(newAC1);
    setAC2(newAC2);
    updatedFields.ac1 = newAC1;
    updatedFields.ac2 = newAC2;
    
    // Recalcular MB
    const ac1Value = parseFloat((newAC1 && newAC1.replace(",", ".")) || 0);
    const ac2Value = parseFloat((newAC2 && newAC2.replace(",", ".")) || 0);
    
    if (ac1Value > 0 || ac2Value > 0) {
      const media = (ac1Value + ac2Value) / 2;
      const roundedMedia = Math.round(media * 10) / 10;
      newMB = roundedMedia.toFixed(1).replace(".", ",");
    }
    
    // Atualizar MB
    setMB(newMB);
    updatedFields.mb = newMB;
    
    // Recalcular MPR
    const mbValue = parseFloat((newMB && newMB.replace(",", ".")) || 0);
    const rmValue = parseFloat((updatedFields.rm && updatedFields.rm.replace(",", ".")) || 0);
    
    if (mbValue > 0 || rmValue > 0) {
      const maxValue = mbValue > rmValue ? mbValue : rmValue;
      const roundedMPR = Math.round(maxValue * 10) / 10;
      newMPR = roundedMPR.toFixed(1).replace(".", ",");
    }
    
    // Atualizar MPR
    setMPR(newMPR);
    
    // Atualizar lastSavedValues
    setLastSavedValues({
      ...updatedFields,
      mb: newMB,
      mpr: newMPR
    });
    
    // Limpar localStorage antes de salvar
    clearLocalStorageData(aluno.AlunoID, TurmaID, DisciplinaID, period);
    
    try {
      // Enviar explicitamente strings vazias para o servidor
      await updateGradesByStudent(
        aluno.AlunoID,
        TurmaID,
        DisciplinaID,
        period,
        updatedFields.at1,
        updatedFields.at2,
        updatedFields.at3,
        updatedFields.at4,
        updatedFields.at5,
        updatedFields.at6,
        updatedFields.ac1,
        updatedFields.ac2,
        updatedFields.rm,
        updatedFields.mb,
        nomeDisciplina,
        updatedFields.visibility
      );
      
      // Mostrar feedback de sucesso
      setSaveStatus({ 
        show: true, 
        success: true, 
        message: "Nota apagada com sucesso" 
      });
      
    } catch (error) {
      console.error(`[EXCLUSÃO] Erro ao salvar dados para aluno ${aluno.AlunoID}:`, error);
      
      // Mostrar erro
      setSaveStatus({ 
        show: true, 
        success: false, 
        message: "Erro ao apagar nota" 
      });
    }
  };
  
  // Função para cancelar a exclusão
  const cancelDeletion = () => {
    setShowDeleteConfirm(false);
  };

  // Verifica se ocorreram mudanças nas notas que justificam um salvamento
  const hasSignificantChanges = (gradeAC1, gradeAC2) => {
    // Se não tivermos valores salvos anteriormente, sempre considere como mudança significativa
    if (!lastSavedValues) return true;
    
    // Converter os valores para o mesmo formato para comparação
    const currentAC1 = gradeAC1 ? gradeAC1.replace(".", ",") : "";
    const currentAC2 = gradeAC2 ? gradeAC2.replace(".", ",") : "";
    const currentRM = RM || "";
    const currentVisibility = visible;
    
    // Normalizar valores "0" para comparação - valores vazios e zeros são tratados como diferentes
    const normalizeForComparison = (value) => value === "0" ? "0" : (value || "");
    
    // Verificar se algum valor mudou em relação ao último salvo
    const changed = 
      normalizeForComparison(currentAC1) !== normalizeForComparison(lastSavedValues.ac1) ||
      normalizeForComparison(currentAC2) !== normalizeForComparison(lastSavedValues.ac2) ||
      normalizeForComparison(currentRM) !== normalizeForComparison(lastSavedValues.rm) ||
      currentVisibility !== lastSavedValues.visibility ||
      normalizeForComparison(AT1) !== normalizeForComparison(lastSavedValues.at1) ||
      normalizeForComparison(AT2) !== normalizeForComparison(lastSavedValues.at2) ||
      normalizeForComparison(AT3) !== normalizeForComparison(lastSavedValues.at3) ||
      normalizeForComparison(AT4) !== normalizeForComparison(lastSavedValues.at4) ||
      normalizeForComparison(AT5) !== normalizeForComparison(lastSavedValues.at5) ||
      normalizeForComparison(AT6) !== normalizeForComparison(lastSavedValues.at6);
    
    // Verificar se o período também mudou (o que seria uma mudança significativa)
    const periodChanged = lastSavedValues.period !== period;
    
    return changed || periodChanged;
  };

  /**
   * Manipula o evento blur (sair do campo) e calcula imediatamente as médias
   * As notas AC1, AC2 e MB são calculadas diretamente antes de salvar no banco
   * Não usa localStorage para armazenamento de dados
   */
  const handleBlur = () => {
    // Resetar erros
    setError(false);
    setErrorMessage("");
    
    // Mostrar feedback visual de processamento
    setSaveStatus({ 
      show: true, 
      success: true, 
      message: "Processando" 
    });
    
    // Formatar valores garantindo que zeros sejam string vazia
    const formattedAT1 = apiFormatGradeValue(AT1);
    const formattedAT2 = apiFormatGradeValue(AT2);
    const formattedAT3 = apiFormatGradeValue(AT3);
    const formattedAT4 = apiFormatGradeValue(AT4);
    const formattedAT5 = apiFormatGradeValue(AT5);
    const formattedAT6 = apiFormatGradeValue(AT6);
    const formattedRM = apiFormatGradeValue(RM);
    
    // Atualizar os estados com os valores formatados
    setAT1(formattedAT1);
    setAT2(formattedAT2);
    setAT3(formattedAT3);
    setAT4(formattedAT4);
    setAT5(formattedAT5);
    setAT6(formattedAT6);
    setRM(formattedRM);

    // Calcular AC1, AC2 e MB
    const at1Value = parseFloat((formattedAT1 && formattedAT1.replace(",", ".")) || 0);
    const at2Value = parseFloat((formattedAT2 && formattedAT2.replace(",", ".")) || 0);
    const at3Value = parseFloat((formattedAT3 && formattedAT3.replace(",", ".")) || 0);
    const at4Value = parseFloat((formattedAT4 && formattedAT4.replace(",", ".")) || 0);
    const at5Value = parseFloat((formattedAT5 && formattedAT5.replace(",", ".")) || 0);
    const at6Value = parseFloat((formattedAT6 && formattedAT6.replace(",", ".")) || 0);
    
    // Calcular AC1
    let calculatedAC1 = "";
    if (at1Value > 0 || at2Value > 0) {
      const soma = at1Value + at2Value;
      const roundedSoma = Math.round(soma * 10) / 10;
      calculatedAC1 = roundedSoma.toFixed(1).replace(".", ",");
    }
    
    // Calcular AC2
    let calculatedAC2 = "";
    if (at3Value > 0 || at4Value > 0 || at5Value > 0 || at6Value > 0) {
      const soma = at3Value + at4Value + at5Value + at6Value;
      const roundedSoma = Math.round(soma * 10) / 10;
      calculatedAC2 = roundedSoma.toFixed(1).replace(".", ",");
    }
    
    // Atualizar AC1 e AC2
    setAC1(calculatedAC1);
    setAC2(calculatedAC2);
    
    // Calcular MB
    let calculatedMB = "";
    if (calculatedAC1 || calculatedAC2) {
      const ac1Num = parseFloat((calculatedAC1 && calculatedAC1.replace(",", ".")) || 0);
      const ac2Num = parseFloat((calculatedAC2 && calculatedAC2.replace(",", ".")) || 0);
      
      if (ac1Num > 0 || ac2Num > 0) {
        const media = (ac1Num + ac2Num) / 2;
        const roundedMedia = Math.round(media * 10) / 10;
        calculatedMB = roundedMedia.toFixed(1).replace(".", ",");
      }
    }
    
    // Atualizar MB
    setMB(calculatedMB);
    
    // Validação de somas
    if ((at1Value + at2Value) > 10 || (at3Value + at4Value + at5Value + at6Value) > 10) {
      if (inputRef.current) {
        setError(true);
        setErrorMessage("A soma das notas não pode ultrapassar o valor 10");
        inputRef.current.focus();
        inputRef.current.style.background = "red";
        setSaveStatus({ show: false, success: false, message: "" });
        return;
      }
    }
    
    // Verificar se houve mudanças
    const hasChanged = !lastSavedValues || 
      formattedAT1 !== lastSavedValues.at1 ||
      formattedAT2 !== lastSavedValues.at2 ||
      formattedAT3 !== lastSavedValues.at3 ||
      formattedAT4 !== lastSavedValues.at4 ||
      formattedAT5 !== lastSavedValues.at5 ||
      formattedAT6 !== lastSavedValues.at6 ||
      formattedRM !== lastSavedValues.rm ||
      visible !== lastSavedValues.visibility ||
      calculatedAC1 !== lastSavedValues.ac1 ||
      calculatedAC2 !== lastSavedValues.ac2 ||
      calculatedMB !== lastSavedValues.mb;
    
    // Salvar se houve mudanças
    if (hasChanged) {
      // Limpar localStorage
      clearLocalStorageData(aluno.AlunoID, TurmaID, DisciplinaID, period);
      
      // Salvar no servidor
      updateGradesByStudent(
        aluno.AlunoID,
        TurmaID,
        DisciplinaID,
        period,
        formattedAT1,
        formattedAT2,
        formattedAT3,
        formattedAT4,
        formattedAT5,
        formattedAT6,
        calculatedAC1,
        calculatedAC2,
        formattedRM,
        calculatedMB,
        nomeDisciplina,
        visible
      )
      .then(data => {
        // Mostrar sucesso
        setSaveStatus({ 
          show: true, 
          success: true, 
          message: "Notas salvas" 
        });
        
        // Atualizar lastSavedValues
        setLastSavedValues({
          at1: formattedAT1,
          at2: formattedAT2,
          at3: formattedAT3,
          at4: formattedAT4,
          at5: formattedAT5,
          at6: formattedAT6,
          ac1: calculatedAC1,
          ac2: calculatedAC2,
          rm: formattedRM,
          mb: calculatedMB,
          visibility: visible,
          period: period
        });
        
        // NOVO: Chamar onGradeSaved passando dados atualizados
        if (typeof onGradeSaved === 'function') {
          onGradeSaved({
            AlunoID: aluno.AlunoID,
            at1: formattedAT1,
            at2: formattedAT2,
            at3: formattedAT3,
            at4: formattedAT4,
            at5: formattedAT5,
            at6: formattedAT6,
            ac1: calculatedAC1,
            ac2: calculatedAC2,
            rm: formattedRM,
            mb: calculatedMB,
            visibility: visible,
            period: period
          });
        }
        setTimeout(() => {
          setSaveStatus(prev => ({ ...prev, show: false }));
        }, 2000);
      })
      .catch(error => {
        console.error(`[SALVAR] Erro ao salvar para aluno ${aluno.AlunoID}:`, error);
        
        // Mostrar erro
        setSaveStatus({ 
          show: true, 
          success: false, 
          message: "Falha ao salvar" 
        });
      });
    } else {
      setSaveStatus({ show: false, success: false, message: "" });
    }
  };

  const handleKeyPress = (event, setter) => {
    if (event.key === "Enter") {
      setOpen(true);
      setValue(event.target.value);
      setCurrentSetter(setter);
    }
  };

  // Nova função para lidar com mudanças de visibilidade individual
  const handleVisibilityChange = async () => {
    // Validar que AlunoID está presente
    if (!aluno.AlunoID && aluno.AlunoID !== 0) {
      setSaveStatus({
        show: true,
        success: false,
        message: "Erro: AlunoID não encontrado"
      });
      setTimeout(() => {
        setSaveStatus(prev => ({ ...prev, show: false }));
      }, 3000);
      return;
    }
    
    // Primeiro atualizamos o estado local (toggles do valor atual)
    const newVisibility = !visible;
    setVisible(newVisibility);
    
    // Mostramos um feedback de carregamento
    setSaveStatus({
      show: true,
      success: true,
      message: "Atualizando visibilidade"
    });
    
    logDebug(`Atualizando visibilidade individual para aluno ${aluno.AlunoID}: ${newVisibility}`);
    
    // Então enviamos para o servidor
    try {
      await updateVisibilityByStudent(
        aluno.AlunoID,
        TurmaID,
        DisciplinaID,
        period,
        newVisibility
      );
      
      // Feedback de sucesso
      setSaveStatus({
        show: true,
        success: true,
        message: "Visibilidade atualizada"
      });
      setTimeout(() => {
        setSaveStatus(prev => ({ ...prev, show: false }));
      }, 2000);
    } catch (error) {
      console.error(`Erro ao atualizar visibilidade individual para aluno ${aluno.AlunoID}:`, error);
      
      // Feedback de erro
      setSaveStatus({
        show: true,
        success: false,
        message: "Erro ao atualizar visibilidade"
      });
    }
  };

  return (
    <StudentsGrades>
      {logDebug("Estado showDeleteConfirm:", showDeleteConfirm, "Campo para apagar:", fieldToDelete.field)}
      <ListStudents>
        {legend && (
          <TitleLegend
            TurmaID={TurmaID}
            period={period}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            onSelectAllChange={onSelectAllChange}
            totalStudents={last}
          />
        )}
        <Checkbox checked={visible} onChange={handleVisibilityChange} />
        {gradeSponte ? (
          // Se há nota do Sponte (mesmo após validate voltar para false), mostrar com nota entre parênteses
          // E aplicar cor vermelha se houver divergência (gradeSponte !== MPR)
          <InputName
            className="finish"
            type="text"
            value={nome + `   -   (${gradeSponte})`}
            onChange={(event) => handleChange(event, setNome)}
            onBlur={handleBlur}
            readOnly
            style={{
              backgroundColor: gradeSponte && gradeSponte !== MPR ? "red" : "",
              color: gradeSponte && gradeSponte !== MPR ? "white" : "inherit",
            }}
          />
        ) : sponteGradesData && sponteGradesData[aluno.AlunoID] ? (
          // Se os dados do Sponte existem mas não há nota (ainda não foi enviada), mostrar mensagem
          <Tooltip
            title="Nota ainda não foi enviada para o Sponte. Clique em 'Calcular Notas Finais' para enviar."
            arrow
            placement="right"
          >
            <InputName
              className="finish"
              type="text"
              value={nome + `   -   (Não enviada)`}
              onChange={(event) => handleChange(event, setNome)}
              onBlur={handleBlur}
              readOnly
              style={{
                backgroundColor: "#ffa500", // Laranja para indicar pendência
                color: "white",
              }}
            />
          </Tooltip>
        ) : (
          // Quando não há dados do Sponte ou não foi verificado ainda, mostrar normalmente com tooltip
          <Tooltip
            title="Clique para ver o boletim desse aluno"
            arrow
            placement="right"
          >
            <InputName
              className="finish"
              type="text"
              value={nome}
              onChange={(event) => handleChange(event, setNome)}
              onClick={() => setOpenResultado(true)}
              onBlur={handleBlur}
              readOnly
            />
          </Tooltip>
        )}

        <InputGradeAC1
          className="grade-input"
          type="text"
          value={AT1}
          onChange={(event) => handleChange(event, setAT1)}
          onBlur={handleBlur}
          onKeyPress={(event) => handleKeyPress(event, "at1")}
          tabIndex={tabIndex}
          disabled={isSaving}
        />
        <InputGradeAC1
          type="text"
          value={AT2}
          onChange={(event) => handleChange(event, setAT2)}
          onBlur={handleBlur}
          onKeyPress={(event) => handleKeyPress(event, "at2")}
          tabIndex={tabIndex + last}
          disabled={isSaving}
        />
        <InputGradeAC2
          type="text"
          value={AT3}
          onChange={(event) => handleChange(event, setAT3)}
          onBlur={handleBlur}
          onKeyPress={(event) => handleKeyPress(event, "at3")}
          tabIndex={tabIndex + 2 * last}
          disabled={isSaving}
        />
        <InputGradeAC2
          type="text"
          value={AT4}
          onChange={(event) => handleChange(event, setAT4)}
          onBlur={handleBlur}
          onKeyPress={(event) => handleKeyPress(event, "at4")}
          tabIndex={tabIndex + 3 * last}
          disabled={isSaving}
        />
        <InputGradeAC2
          type="text"
          value={AT5}
          onChange={(event) => handleChange(event, setAT5)}
          onBlur={handleBlur}
          onKeyPress={(event) => handleKeyPress(event, "at5")}
          tabIndex={tabIndex + 4 * last}
          disabled={isSaving}
        />
        <InputGradeAC2
          type="text"
          value={AT6}
          onChange={(event) => handleChange(event, setAT6)}
          onBlur={handleBlur}
          onKeyPress={(event) => handleKeyPress(event, "at6")}
          tabIndex={tabIndex + 5 * last}
          disabled={isSaving}
        />
        <InputMediaAC1
          type="text"
          value={AC1}
          onChange={(event) => handleChange(event, setAC1)}
          onBlur={handleBlur}
          style={{
            fontWeight: "bold",
            backgroundColor:
              AC1 && parseFloat(AC1.replace(",", ".")) > 10 ? "red" : "inherit",
          }}
          readOnly
        />
        <InputMediaAC2
          type="text"
          value={AC2}
          onChange={(event) => handleChange(event, setAC2)}
          onBlur={handleBlur}
          style={{
            fontWeight: "bold",
            backgroundColor:
              AC2 && parseFloat(AC2.replace(",", ".")) > 10 ? "red" : "inherit",
          }}
          readOnly
        />
        <InputMB
          type="text"
          value={MB}
          onChange={(event) => handleChange(event, setMB)}
          onBlur={handleBlur}
          style={{
            fontWeight: "bold",
            color: MB && parseFloat(MB.replace(",", ".")) < 7 ? "red" : "blue",
          }}
          readOnly
        />
        <InputRM
          type="text"
          value={RM}
          onChange={(event) => handleChange(event, setRM)}
          onBlur={handleBlur}
          tabIndex={tabIndex + 9 * last}
          disabled={isSaving}
        />
        <InputMPR
          type="text"
          value={MPR}
          onChange={(event) => handleChange(event, setMPR)}
          onBlur={handleBlur}
          style={{
            fontWeight: "bold",
            // Se houver divergência com Sponte, aplicar fundo vermelho (igual ao nome do aluno)
            // Caso contrário, apenas cor do texto vermelha se nota < 7 (igual versão antiga)
            backgroundColor: (gradeSponte && gradeSponte !== MPR) ? "red" : 
                           (MPR && parseFloat(MPR.replace(",", ".")) < 7) ? "inherit" : "inherit",
            color: (gradeSponte && gradeSponte !== MPR) ? "white" :
                   (MPR && parseFloat(MPR.replace(",", ".")) < 7) ? "red" : "blue",
          }}
          readOnly
        />
      </ListStudents>
      
      <Snackbar
        open={saveStatus.show}
        autoHideDuration={1500}
        onClose={() => setSaveStatus(prev => ({ ...prev, show: false }))}
        message={saveStatus.message}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: saveStatus.success ? "#4caf50" : "#f44336",
            color: "white",
            fontWeight: "bold",
            borderRadius: "4px",
            fontSize: "14px",
            minWidth: "200px",
            textAlign: "center"
          }
        }}
      />
      
      <AlertDialog
        open={open}
        setOpen={setOpen}
        title="Alterar notas em massa"
        body={"Você deseja repetir essa nota para todos os alunos?"}
        handleConfirm={async () => {
          try {
            repeatGrades(value, currentSetter);
          } catch (error) {
            logDebug(error);
            setError(true);
            setErrorMessage("Erro ao repetir nota para todos os alunos");
          }
        }}
      />
      
      {/* Modal de confirmação para apagar notas */}
      <AlertDialog
        open={showDeleteConfirm}
        setOpen={setShowDeleteConfirm}
        title="Confirmar exclusão"
        body={`Tem certeza que deseja apagar a nota ${fieldToDelete.field}? Esta ação não pode ser desfeita.`}
        handleConfirm={confirmDeletion}
        handleCancel={cancelDeletion}
      />
      
      <ModalResultado
        open={openResultado}
        setOpen={setOpenResultado}
        aluno={aluno}
        TurmaID={TurmaID}
      />
    </StudentsGrades>
  );
};
